import { useAppAction, useAppSelector } from '../hooks';
import {
  creditsManagementFetchCreditTypesThunk,
  FetchCompanyCreditsForPaymentThunk,
  fetchCompanyCreditUsageListThunk,
  fetchCreditCompanyBalancesThunk,
  useFetchManagementCreditsThunk,
} from './creditsManagementActions';
import { CREDITS_MANAGEMENT_NAMESPACE } from './creditsManagementReducer';
import { CreditsManagementState } from './creditsManagementTypes';

export function useCreditsManagementSelector<
  T extends (state: CreditsManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[CREDITS_MANAGEMENT_NAMESPACE])
  );
}

export const useCreditCompanyManagementCredits = () =>
  useCreditsManagementSelector((state) => {
    return state.company.management;
  });

export const useActiveCreditCompanyManagementCredits = () =>
  useCreditsManagementSelector((state) => {
    return state.company.activeManagementCredit;
  });

export const useCreditsCompanyManagementUsageCredits = () =>
  useCreditsManagementSelector((state) => {
    return state.company.usage;
  });

export const useCreditCompanyManagementTypes = () =>
  useCreditsManagementSelector((state) => {
    return state.company.creditTypes;
  });

export const useCreditUsageList = () =>
  useCreditsManagementSelector((state) => {
    return state.usageList;
  });

export const useFetchCreditManagementCredits = () =>
  useAppAction(useFetchManagementCreditsThunk);

export const useFetchCreditCompanyBalances = () =>
  useAppAction(fetchCreditCompanyBalancesThunk);

export const useFetchCreditTypes = () =>
  useAppAction(creditsManagementFetchCreditTypesThunk);

export const useFetchCompanyCreditsForPayments = () =>
  useAppAction(FetchCompanyCreditsForPaymentThunk);

export const useFetchCompanyCreditUsageList = () =>
  useAppAction(fetchCompanyCreditUsageListThunk);
